// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zXiZ0","type":"styles_type__2azmO","choices":"styles_choices__3nqFA"};